import { ApeironBlueButton, NextImage, OkxSVG } from '@apeiron/temp'
import { styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Button = styled(ApeironBlueButton)`
  --background-color: white;
  max-height: 50px;
  border-radius: 4px;
  color: white;
  flex: 1;
  font-size: 16px;
  gap: 6px;
  height: 50px;
  margin-left: auto;
  width: 100%;

  color: black;
  flex: 0.5;
  min-width: 140px;

  :hover {
    filter: brightness(0.9);
  }
`

const OkWalletIcon = styled(NextImage)`
  width: 24px;
  height: 24px;
`

const OkxWalletButton = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <Button onClick={onClick}>
      <OkWalletIcon src={OkxSVG} />
      {t('login.general.button.okx')}
    </Button>
  )
}

type Props = {
  onClick: () => void
}

export default OkxWalletButton
